import { StoredValueDetailsPage } from './stored-value-details-page.component';

const PAGE_TITLE = 'Stored Value Program';

export const StoredValueDetailsPageContainer = () => {
  return <StoredValueDetailsPage title={PAGE_TITLE} />;
};
